<div>
  <app-titlebar #titlebar>
  </app-titlebar>

</div>

<mat-card>
  <mat-card-header>
    <mat-card-title>網頁路徑錯誤</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <p>您所輸入的網頁路徑不存在，請請回首頁。</p><button (click)="goRoot()" class="btn-neutral">回首頁</button>
  </mat-card-content>
</mat-card>
